<div class="position-relative">
    <div class="d-flex justify-content-center align-items-center avatar avatar-background demo">
        <div class="position-absolute top-50 start-50 translate-middle text-white fw-bold font-monospace">DEMO</div>
    </div>

    <!-- Notifications Badge -->
    @if (hasNotifications) {
        <span
            class="position-absolute top-0 end-0 p-1 rounded-circle bg-danger">
        <span class="visually-hidden">New release notes</span>
    </span>
    }
</div>
